var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-row',_vm._l((_vm.gardens),function(garden){return _c('v-col',{key:garden.id},[_c('garden-card',{attrs:{"garden-id":garden.id}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }